var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast show",class:[
    _vm.variant,
    _vm.customClass,
    {
      enter: _vm.isEntering,
      exit: _vm.isExiting,
    },
  ]},[(!_vm.showIcon)?_c('div',{staticClass:"status-bar"}):_c('div',{staticClass:"status-icon"},[_c(_vm.icon,{tag:"component"})],1),_c('div',{staticClass:"text-container"},[_c('strong',{staticClass:"text-regular bold",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{staticClass:"content text-medium",domProps:{"innerHTML":_vm._s(_vm.content)}})]),(!_vm.hideCloseBtn)?_c('button',{staticClass:"button",on:{"click":function($event){return _vm.$emit('close')}}},[_c('UilTimes',{attrs:{"size":"24"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }